import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'
import { useRegionStore } from '@/stores/region-store'
import { postApiV1LotteryVideoList } from '@/api/sdk.gen'
import type { LotteryVideoItem } from '@/api/types.gen'

const CURRENT_YEAR = new Date().getFullYear()

export const useVideoStore = defineStore('video-store', () => {
  const regionStore = useRegionStore()

  const selectedYear = ref(CURRENT_YEAR)
  const videoList = ref<LotteryVideoItem[]>([])
  const loading = ref(false)

  function getLotteryTypeNum(): 1 | 2 {
    return regionStore.region === 'hk' ? 1 : 2
  }

  const latestFour = computed(() => videoList.value.slice(0, 4))

  function findByPeriod(period: number): LotteryVideoItem | undefined {
    return videoList.value.find((v) => v.period === period)
  }

  async function fetchAll(year?: number) {
    if (loading.value) return
    loading.value = true
    if (year != null) selectedYear.value = year
    try {
      const res = await postApiV1LotteryVideoList({
        query: {
          lotteryType: getLotteryTypeNum(),
          year: selectedYear.value,
          pageSize: 999,
          pageNum: 1,
        },
      })
      videoList.value = res.data?.data?.recordList ?? []
    } finally {
      loading.value = false
    }
  }

  watch(
    () => regionStore.region,
    () => {
      fetchAll()
    },
  )

  return {
    selectedYear,
    videoList,
    loading,
    latestFour,
    findByPeriod,
    fetchAll,
  }
})
